;(function() {
  'use strict'

  service.$inject = ["$q", "glDialog"];
  angular.module('core.elementSelector').factory('elementSelector', service)

  /* @ngInject */
  function service($q, glDialog) {
    return {
      prompt: prompt,
    }

    function prompt(elements) {
      return $q(function(resolve, reject) {
        glDialog
          .show({
            templateUrl: 'element-selector.template.html',
            controller: 'ElementSelector',
            locals: {
              elements: elements,
            },
          })
          .then(resolve, reject)
      })
    }
  }
})()
